import React from "react"
import Grid from '@material-ui/core/Grid';
import Layout from "../components/layout"
import PremiumServices from "../components/Sidebar/PremiumServices"
import "@fortawesome/fontawesome-svg-core/styles.css"
import Twitter from "../images/Twitter.png"
import Seo from "../components/seo"
import { makeStyles, } from '@material-ui/core/styles';
import "../components/pageStyles.scss"
import warning from "../images/warning.jpeg"

const useStyles = makeStyles((theme) => ({
  root: {
    "&:hover": {
      color: "#b60011",   
    },
  },
}));

const CiWeatherWarning = () => {
  const hoverStyle = useStyles();
      return (
          <React.Fragment>
            <Layout>
            <Seo title="CI weather warnings" description="Weather warnings for the Channel Islands via the @Jersey_MetCI Twitter feed." />
            <div className="forecastAutoMargin">
            <Grid item xs={12} sm={12} md={8} lg={8} className="menuTitle" style={{paddingLeft:0}}>
                  <h1>
                  CI weather warnings
                  </h1>                  
          </Grid>
              <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={8} lg={8}>
                  {/* <div style={{backgroundColor:"#deb02c", borderRadius:"10px", color:"white", padding:"10px"}} >
                    <img src={warning} style={{width:"119px"}} alt="" />
                    <span style={{fontSize:"28px", paddingLeft:"10px"}}>Wind warnings sevice -  Warning amber</span>
                  </div>
                  <p>SW to S gale with gusts 55kt veeringh W to NW imminent</p>
                  <p>Warning Tueday</p> */}
                  <div className="Content">
                    <h2 style={{marginTop:0}}>Stay up to date with weather warnings</h2>
                    <p> We post weather warnings on Twitter. You don't need a Twitter account to see them.</p>                    
                      <p>
                      <a className={hoverStyle.root} style={{fontSize:"24px", lineHeight:"20px"}} target="_blank" rel="noreferrer" href="https://twitter.com/Jersey_MetCI">
                      <img style={{width:"150px", paddingBottom:"10px", marginRight:"10px"}} alt={Twitter} src={Twitter}/>Weather warnings on Twitter</a>
                      {/* <FontAwesomeIcon className="fa-layers fa-fw" style={{fontSize:"48px", color:"rgba(29,161,242,1.00)"}} icon={faTwitter}  inverse transform="shrink-6" /> */}                
                      </p>
                   <p>Can't see the Twitter feed? You need to upgrade your browser to the latest version.</p>

                  </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                  <PremiumServices />
                </Grid>
              </Grid>
              </div>
            </Layout>
          </React.Fragment>
      )
  }
  export default CiWeatherWarning;